// Legacy alias for external @core/journeys/ui/getStepTheme imports —
// the canonical home is ../block.
export { getStepTheme } from '../block/getStepTheme'
